"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var backgrounds_styled_1 = require("../styled/backgrounds.styled");

var ModulesBackground =
/** @class */
function (_super) {
  __extends(ModulesBackground, _super);

  function ModulesBackground() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ModulesBackground.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        height = _a.height,
        activeBreakpoint = _a.activeBreakpoint,
        shouldExpand = _a.shouldExpand,
        onLayoutHandler = _a.onLayoutHandler;
    return React.createElement(BackgroundContainerDecorated, {
      height: height,
      activeBreakpoint: activeBreakpoint,
      backgroundColor: "#F6E8D6",
      position: "relative",
      shouldExpand: shouldExpand,
      onLayoutHandler: onLayoutHandler
    }, children);
  };

  return ModulesBackground;
}(React.Component);

var BackgroundContainerDecorated = styled_components_1.default(backgrounds_styled_1.BackgroundContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow-x: hidden;\n    background: #f6e8d6;\n"], ["\n    overflow-x: hidden;\n    background: #f6e8d6;\n"])));
exports.default = responsive_1.withResponsiveMeta(ModulesBackground);
var templateObject_1;